import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { inSkipList } from '.';
import { EnterpriseStore } from '../stores/enterprise.store';
import { FacilityStore } from '../stores/facility.store';

@Injectable()
export class TenantInterceptor implements HttpInterceptor {
  constructor(
    private facilityStore: FacilityStore,
    private enterpriseStore: EnterpriseStore,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isApiCall = req.url.startsWith(environment.apiDomain) && !inSkipList(req.url);
    const isTenantRequest = ['POST', 'PUT', 'PATCH'].includes(req.method);

    if (isApiCall && isTenantRequest) {
      if (req.body instanceof FormData) {
        const formData = new FormData();

        req.body.forEach((value, key) => {
          formData.append(key, value);
        });

        if (!formData.has('enterpriseId')) {
          const enterpriseId = req.body.get('enterpriseId') || this.getCurrentEnterpriseId();
          if (enterpriseId) {
            formData.append('enterpriseId', enterpriseId);
          }
        }

        if (!formData.has('facilityId')) {
          const facilityId = req.body.get('facilityId') || this.getCurrentFacilityId();
          if (facilityId) {
            formData.append('facilityId', facilityId);
          }
        }

        const clonedRequest = req.clone({ body: formData });
        return next.handle(clonedRequest);
      }

      if (this.shouldAddTenantInformation(req.body)) {
        const currentEnterpriseId = req.body.enterpriseId ?? this.getCurrentEnterpriseId();
        const currentFacilityId = req.body.facilityId ?? this.getCurrentFacilityId();

        const clonedRequest = req.clone({
          body: {
            ...req.body,
            enterpriseId: currentEnterpriseId,
            facilityId: currentFacilityId,
          },
        });

        return next.handle(clonedRequest);
      }
    }

    return next.handle(req);
  }

  shouldAddTenantInformation(body: any): boolean {
    return typeof body === 'object' && body !== null && !Array.isArray(body);
  }

  getCurrentEnterpriseId(): string | null {
    return this.enterpriseStore.getCurrentEnterpriseId();
  }

  getCurrentFacilityId(): string | null {
    return this.facilityStore.getCurrentFacilityId();
  }
}
